import { Component, Input } from '@angular/core';
import { AdComponent } from './ad.component';

@Component({
  template: `
    <div class="add-component" [style.background-image]="data.src"></div>
  `
})
export class SalesInfoAddComponent implements AdComponent {
  @Input() data: any;
}





// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/adds/sales-info-adds-component.ts